import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-qr-switch',
  templateUrl: './qr-switch.component.html',
  styleUrls: ['./qr-switch.component.css']
})
export class QrSwitchComponent {
  @Input() value: boolean = false;
  @Input() label: string = '';
  @Input() title: string = '';
  @Output() valueChange = new EventEmitter<boolean>();

  toggle() {
    this.value = !this.value;
    this.valueChange.emit(this.value);
  }
}



// WEBPACK FOOTER //
// /app/src/app/components/ui/qr-switch/qr-switch.component.ts